export default __webpack_public_path__ + "static/media/ic_import.b9c96bfd.svg";